import { render } from "./Verify.vue?vue&type=template&id=75f820a8"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"
script.render = render

export default script